import graphql from "babel-plugin-relay/macro";

export const USER_NAME_FRAGMENT = graphql`
    fragment userNameColumn_Fragment on User {
        extension(userExtensionKind: InfectopharmUserExtension) {
            ... on InfectopharmUserExtension {
                firstName
                lastName
            }
        }
    }
`;
